import React from "react"
import { FormControl } from "../gluestack/form-control"
import {
  SelectInput as GluestackSelectInput,
  Select,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicator,
  SelectDragIndicatorWrapper,
  SelectIcon,
  SelectItem,
  SelectPortal,
  SelectTrigger,
} from "../gluestack/select"
import { FieldError } from "./FieldError"
import { FieldLabel } from "./FieldLabel"

type SelectInputProps = {
  value?: string
  handleChange: (value: string) => void
  options: Array<{ value: string; label: string }>
  label?: string
  name: string
  required?: boolean
  className?: string
  disabled?: boolean
  hideError?: boolean
  error?: string
}

export const SelectInput: React.FC<SelectInputProps> = (props) => {
  const {
    value,
    handleChange,
    options,
    className,
    hideError,
    disabled,
    label,
    required,
    error,
  } = props

  const safeValue = value || ""

  return (
    <FormControl
      className={className}
      isInvalid={!!error}
      isRequired={required}
      isDisabled={disabled}
    >
      <FieldLabel label={label} required={required} />
      <Select
        selectedValue={safeValue}
        onValueChange={handleChange}
        isDisabled={disabled}
      >
        <SelectTrigger>
          <GluestackSelectInput placeholder="Select option" />
          <SelectIcon />
        </SelectTrigger>
        <SelectPortal>
          <SelectBackdrop />
          <SelectContent>
            <SelectDragIndicatorWrapper>
              <SelectDragIndicator />
            </SelectDragIndicatorWrapper>
            {options.map((option) => (
              <SelectItem
                key={option.value}
                label={option.label}
                value={option.value}
              />
            ))}
          </SelectContent>
        </SelectPortal>
      </Select>
      {!hideError && <FieldError error={error} />}
    </FormControl>
  )
}
